import { useMutation } from '@apollo/client';

import { ADMIN_EVENT_TRANSACTIONS } from '../../event/graphql/query/adminEventTransactionsQuery.graphql';
import { STAFF_REFUND_TRANSACTION } from '../graphql/mutations/staffRefundTransactionMutation.graphql';

export const useStaffRefundTransactionMutation = () => {
  const [mutate] = useMutation(STAFF_REFUND_TRANSACTION, {
    refetchQueries: [ADMIN_EVENT_TRANSACTIONS],
  });

  const refundTransaction = (transactionId: string) => {
    mutate({
      variables: {
        transactionId,
      },
    });
  };

  return { refundTransaction };
};
